import {createContext, useContext} from "react";

/**
 * Inactive facilities can't be edited: every field and action of the facility settings page is
 * disabled, and fields show the lock icon.
 */
const FacilitySettingsReadOnlyContext = createContext(false);

export const FacilitySettingsReadOnlyProvider =
  FacilitySettingsReadOnlyContext.Provider;

export const useIsFacilitySettingsReadOnly = (): boolean =>
  useContext(FacilitySettingsReadOnlyContext);
